export default __webpack_public_path__ + "static/media/renan-nav.64db2813.gif";